import { render } from "./OfflineExamStats.vue?vue&type=template&id=19d76f06&scoped=true"
import script from "./OfflineExamStats.vue?vue&type=script&lang=js"
export * from "./OfflineExamStats.vue?vue&type=script&lang=js"

import "./OfflineExamStats.vue?vue&type=style&index=0&id=19d76f06&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d76f06"]])

export default __exports__